const getStyles = (boundingRect: ClientRect | null): {
  root: {
    [key: string]: string | number
  }
} => ({
  root: {
    position: 'absolute',
    top: (boundingRect && boundingRect.top - 38) || '50%',
    left: (boundingRect && boundingRect.left - 48) || '50%'
  }
});

export default getStyles;
